import axios from 'axios'
import { Coordinates } from 'common/types'

export const isDevelopment = process.env.NODE_ENV === 'development'

export const getQuestionKey = (q: number, num: number) => {
  return `q${q}-${num}`
}

export const isNumeric = (value: any) => {
  return !isNaN(parseFloat(value)) && isFinite(value)
}

export const convertCoordinates = (bounds: [[number, number], [number, number]]): Coordinates => {
  const northWest = bounds[0]
  const southEast = bounds[1]
  return [
    [northWest[1], northWest[0]],
    [southEast[1], northWest[0]],
    [southEast[1], southEast[0]],
    [northWest[1], southEast[0]],
  ]
}

export const getSinsuiDisplayValue = (value: string) => {
  if (!value) {
    return ''
  } else if (value === '~0.5m') {
    return `${value} (1階床下)`
  } else if (value === '0.5m~3.0m') {
    return `${value} (1階浸水程度)`
  } else if (value === '3.0m~5.0m') {
    return `${value} (2階浸水程度)`
  } else {
    return `${value} (3階以上浸水程度)`
  }
}

export const compareHelper = (order: { key: string; reverse: boolean }[]) => {
  return (a: any, b: any) => {
    for (let i = 0; i < order.length; i++) {
      const order_by = order[i].reverse ? 1 : -1
      if (a[order[i].key] < b[order[i].key]) return order_by
      if (a[order[i].key] > b[order[i].key]) return order_by * -1
    }
    return 0
  }
}

export const isValidPostalCode = (val: string) => {
  const postalCodePattern = /^[0-9]{3}-?[0-9]{4}$/
  return postalCodePattern.test(val)
}

export const getHeartrailsAddresses = async (keyword: string) => {
  let params = {}
  if (isValidPostalCode(keyword)) {
    params = {
      'method': 'searchByPostal',
      'postal': keyword.replace('-', '')
    }
  } else {
    params = {
      'method': 'suggest',
      'keyword': keyword,
      'matching': 'like'
    }
  }
  const res = await axios.get('https://geoapi.heartrails.com/api/json', { params })
    .then(r => r.data)
    .catch(() => null)
  let targets = []
  if (res !== null && res.response && res.response.location) {
    targets = res.response.location
      .map((row: any) => {
        return {
          name: `${row.prefecture}${row.city}${row.town}`,
          lat: row.y,
          lng: row.x,
        }
      })
  }
  return targets
}

export const toHalfWidthNum = (str: string) => {
  return str.replace(/[０-９]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) - 0xfee0)
  )
}
